import {useState} from "react";
import {useRpcSender} from "../../RpcSender";
import {BillingConfigRequest, BillingConfigResponse} from "../../compiled";
import {RpcState} from "../RpcState";

type Props = {}

/**
 * Redirects the user to stripe to configure their payment methods.
 */
export const useConfigurePaymentMethods = () => {

  const rpcSender = useRpcSender();
  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});

  const send = () => {

    setRpcState({state: 'pending'});
    rpcSender.send('billing_config', BillingConfigRequest.encode({}).finish())
        .then(r => {
          let response = BillingConfigResponse.decode(r);
          if (response.portalUrl) {
            window.location.href = response.portalUrl;
          } else {
            setRpcState({state: 'error', message: "Server error, please try again."});
          }
        })
        .catch(e => {
          setRpcState({state: 'error', message: "Network error, please try again."});
        });
  };

  return {send, rpcState}
}